import React, { useState, useEffect } from "react";
import SalaryInformationStyles from "./SalaryInformation.styles";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import YhInput from "../../../../../ui/YhInput";
import YhButton from "../../../../../ui/YhButton";
import {
  getPerosnalDetails,
  getSalaryDetail,
  saveSalaryDetails,
  updateSalaryInfo,
} from "../StepperService";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import { handleValidation, initialState } from "./SalaryValidation";
const _ = require("lodash");

interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
  userId: string;
  handleCloseAddTeam: Function;
  fromSettingOrLogout?: any;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

let clonedObject = {};

const SalaryInformation = (props: CustomProps) => {
  const classes = SalaryInformationStyles;
  const [salaryInformation, setsalaryInformation] = useState<any>({

    ...initialState({}) ,   
        EPF_opt: false,
        ESI_opt: false,
        i_tax: "000",
        EPF_no: "lasdkj",
        ESI_no: "alskdjf",
  }
  );
  console.log(salaryInformation,"salaryInformation::::::::::::")
  const [showPFInput, setShowPFInput] = useState(false);
  const [showESIInput, setShowESIInput] = useState(false);
  const [apiResponse, setApiResponse] = useState(false);
  const [personalInfo, setPersonalInfo] = useState<any>({});
  const [dataFlag, setDataFlag] = React.useState<Number>(0);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    if (props.userId) {
      try {
        setApiResponse(true);
        const response = await getPerosnalDetails(props.userId);
        customErrorHandler(response);
        setPersonalInfo({
          personalInfo,
          employee_id: response.data.employee_id,
          name: response.data.name,
          doj: response.data.doj,
          uan: response.data.uan ?? "**** **** ****",
        });
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        {
          error.message !== "Data not found" && openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
        }
      }
    }
    if (props.userId) {
      try {
        setApiResponse(true);
        const response = await getSalaryDetail(props.userId);
        customErrorHandler(response);
        console.log(response.data,"responseeeeeeeeeeeeeeeeeeee")
        setsalaryInformation(initialState(response.data));
        setDataFlag(response.success ?? 0);
        clonedObject = _.cloneDeep(response.data);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        {
          error.message !== "Data not found" && openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
        }
      }
    }
  };

  const handleOnChangeInputField = (event: React.ChangeEvent<any>) => {
    // if (typeof event.target.value === "number") {
      setsalaryInformation({
        ...salaryInformation,
        [event.target.name]:{ value: event.target.value, error: "" },
      });
    // }
    // setsalaryInformation({
    //   ...salaryInformation,
    //   [event.target.name]: { value: event.target.value, error: "" },
    // });
  };

  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    

    if (name === "EPF_opt") {
      // setShowPFInput(checked);
      setsalaryInformation({ ...salaryInformation, EPF_opt: checked  });
    } else if (name === "ESI_opt") {
      // setShowESIInput(checked);
      setsalaryInformation({ ...salaryInformation, ESI_opt: checked });
    }
  };

  const submitForm = async () => {
    const validatedObject: any = handleValidation(salaryInformation);
    if (
      validatedObject?.HRA.error || 
      validatedObject?.basic.error  
      // validatedObject?.medical_allowance.error || 
      // validatedObject?.conbeyance_allowance.error || 
      // validatedObject?.special_allowance.error || 
      // validatedObject?.others.error 
    ) {
      setsalaryInformation({ ...validatedObject });
      return;
    }
if (
  props.userId &&
  _.isEqual(clonedObject, salaryInformation) &&
  dataFlag
) {
  props.nextStep?.();
  props.handleCloseAddTeam();
} else if (props.userId && dataFlag) {
  try {
    setApiResponse(true);
    console.log("helllooooooo")
    const body = { ...salaryInformation,
      basic:salaryInformation.basic.value,
      HRA:salaryInformation.HRA.value,
      medical_allowance:salaryInformation.medical_allowance.value || "",
      conbeyance_allowance:salaryInformation.conbeyance_allowance.value || "",
      special_allowance:salaryInformation.special_allowance.value ||"",
      others:salaryInformation.others.value || "",
      _id:(salaryInformation._id.value),
    

      userId: props.userId}
    body.id = salaryInformation._id.value;
    console.log(body,"sfdadfasf")

    const response = await updateSalaryInfo(body);
    if (response?.success) {
      setsalaryInformation(response.data);
      openSuccessNotification(response?.message);
      props.nextStep?.();
      props.handleCloseAddTeam();
    } else {
      customErrorHandler(response);
    }
    setApiResponse(false);
  } catch (error: any) {
    setApiResponse(false);
    openErrorNotification(
      isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
    );
  }
} else {
  try {
    
    setApiResponse(true);
    console.log("hiiiiiiiiiiiiiiiiii")
    const body = { ...salaryInformation,
      basic:salaryInformation.basic.value,
      HRA:salaryInformation.HRA.value,
      medical_allowance:salaryInformation.medical_allowance.value || "",
      conbeyance_allowance:salaryInformation.conbeyance_allowance.value || "",
      special_allowance:salaryInformation.special_allowance.value ||"",
      others:salaryInformation.others.value || "",
      _id:(salaryInformation._id.value),

      userId: props.userId  };
      console.log(body,"jadfkadjfakfba")
    const response = await saveSalaryDetails(body);
    if (response?.success) {
      setsalaryInformation(response.data);
      openSuccessNotification(response?.message);
      props.nextStep?.();
      props.handleCloseAddTeam();
    } else {
      customErrorHandler(response);
    }
    setApiResponse(false);
  } catch (error: any) {
    setApiResponse(false);
    openErrorNotification(
      isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
    );
  }
}
};
  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const handleBackBtn = () => {
    props.backStep?.();
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const inputs = document.getElementsByTagName("input");
      const currentIndex = Array.from(inputs).indexOf(
        event.target as HTMLInputElement
      );
      const nextIndex = currentIndex + 1;

      if (nextIndex < inputs.length) {
        inputs[nextIndex].focus();
      } else {
        // If the last input field is reached, trigger the submitForm function
        submitForm();
      }
    }
  };

  return (
    <div className="w-full">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-[#111827]">Salary Information</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Update your salary information for the platform
        </p>
      </div>

      <div className="mb-6 mt-5">
        <h3 className="text-base font-semibold text-[#111827]">Salary Details</h3>
        <p className="mt-1 text-sm text-[#6B7280]">
          {props.fromSettingOrLogout === "fromSettingOrLogout"
            ? "Manage your salary information"
            : "Manage salary information"}
        </p>
      </div>

      <h4 className="mb-4 text-sm font-semibold text-[#111827]">
        Employee Salary Details
      </h4>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <YhInput
          label="Employee ID"
          placeholder="1124"
          value={personalInfo?.employee_id || ""}
          name="employee_id"
          onKeyPress={handleKeyPress}
          readOnly
        />

        <YhInput
          label="Full Name"
          placeholder="Amit Kumar"
          value={personalInfo?.name || ""}
          name="name"
          onKeyPress={handleKeyPress}
          readOnly
        />

        <FormGroup>
          <FormControlLabel
            control={<Checkbox />}
            label="EPF Applicable"
            checked={salaryInformation?.EPF_opt}
            sx={classes.CheckLabel}
            name="EPF_opt"
            onChange={handleCheckboxChange}
          />
        </FormGroup>

        <FormGroup>
          <FormControlLabel
            control={<Checkbox />}
            label="ESI Applicable"
            checked={salaryInformation?.ESI_opt}
            sx={classes.CheckLabel}
            name="ESI_opt"
            onChange={handleCheckboxChange}
          />
        </FormGroup>

        {(salaryInformation?.EPF_opt || salaryInformation?.ESI_opt) && (
          <>
            {salaryInformation?.EPF_opt && (
              <YhInput
                label="EPF No."
                placeholder="XXXXXXX"
                value={salaryInformation?.EPF_no}
                onChange={handleOnChangeInputField}
                name="EPF_no"
                onKeyPress={handleKeyPress}
              />
            )}

            {salaryInformation?.ESI_opt && (
              <YhInput
                label="ESI No."
                placeholder="XXXXXXX"
                value={salaryInformation?.ESI_no}
                onChange={handleOnChangeInputField}
                name="ESI_no"
                onKeyPress={handleKeyPress}
              />
            )}
          </>
        )}

        <div className="lg:col-span-2">
          <h4 className="text-sm font-semibold text-[#111827]">Salary Payable</h4>
        </div>

        <YhInput
          label="Basic Salary"
          placeholder="XXXXXXX"
          value={salaryInformation?.basic.value || ""}
          onChange={handleOnChangeInputField}
          name="basic"
          error={salaryInformation?.basic?.error}
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="HRA"
          placeholder="XXXXXXX"
          value={salaryInformation?.HRA.value || ""}
          onChange={handleOnChangeInputField}
          name="HRA"
          onKeyPress={handleKeyPress}
          error={salaryInformation?.HRA?.error}
        />

        <YhInput
          label="Medical Allowance (If any)"
          placeholder="XXXXXXX"
          value={salaryInformation?.medical_allowance.value || ""}
          onChange={handleOnChangeInputField}
          name="medical_allowance"
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="Conveyance Allowance (If any)"
          placeholder="XXXXXXX"
          value={salaryInformation?.conbeyance_allowance.value || ""}
          onChange={handleOnChangeInputField}
          name="conbeyance_allowance"
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="Special Allowance (If any)"
          placeholder="XXXXXXX"
          value={salaryInformation?.special_allowance.value || ""}
          onChange={handleOnChangeInputField}
          name="special_allowance"
          onKeyPress={handleKeyPress}
        />

        <YhInput
          label="Other Allowance (if any)"
          placeholder="XXXXXXX"
          value={salaryInformation?.others.value || ""}
          onChange={handleOnChangeInputField}
          name="others"
          onKeyPress={handleKeyPress}
        />

        {(salaryInformation?.EPF_opt || salaryInformation?.ESI_opt) && (
          <>
            <div className="lg:col-span-2">
              <h4 className="text-sm font-semibold text-[#111827]">
                Salary Deduction
              </h4>
            </div>

            {salaryInformation?.EPF_opt && (
              <YhInput
                label="EPF Deduction (12% of basic salary)"
                value={
                  salaryInformation?.basic.value
                    ? +salaryInformation?.basic.value * 0.12
                    : 0
                }
                onKeyPress={handleKeyPress}
                readOnly
              />
            )}

            {salaryInformation?.ESI_opt && (
              <YhInput
                label="ESI Deduction (2% of basic salary)"
                value={
                  salaryInformation?.basic.value
                    ? +salaryInformation?.basic.value * 0.02
                    : 0
                }
                onKeyPress={handleKeyPress}
                readOnly
              />
            )}
          </>
        )}

        <div className="mb-2 flex flex-wrap gap-3 lg:col-span-2">
          {props.hideFooterButtons ? null : (
            <>
              <YhButton variant="secondary" onClick={handleBackBtn}>
                Back
              </YhButton>
              <YhButton variant="primary" onClick={submitForm}>
                Save
              </YhButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalaryInformation;
